import { Link } from "react-router-dom";
import logo from "@/assets/2022_COSMO_Signet_white.svg";
import HeaderButton, { type MenuLink } from "./HeaderButton";
import MobileHeader from "./MobileHeader";
import {
  HomeIcon,
  ChartBarIcon,
  BuildingLibraryIcon,
} from "@heroicons/react/20/solid";
import useWindowWidth from "@/hooks/useWindowWidth";
import { Tooltip } from "react-tooltip";

type Props = {
  children?: React.ReactNode;
};

const menuLinks: MenuLink[] = [
  {
    name: "Übersicht",
    mobileVisibility: true,
    order: 1,
    url: "/",
    icon: HomeIcon,
    visible: true,
  },
  {
    name: "Analysen",
    mobileVisibility: true,
    order: 2,
    url: "/analysis",
    icon: ChartBarIcon,
    visible: true,
  },
  {
    name: "Leads",
    mobileVisibility: true,
    order: 3,
    url: "/leads",
    icon: BuildingLibraryIcon,
    visible: true,
  },
];

function Header({ children }: Props) {
  const windowWidth = useWindowWidth();

  return (
    <nav className="flex justify-between items-center h-14 gap-2 shrink-0 relative z-10">
      <div className="flex items-center gap-2">
        <Link to="/" className="text-xl m-0 flex items-center gap-2">
          <img src={logo} alt="" className="h-6" />
          <p className="">COSMO</p>
        </Link>
        {children}
      </div>
      {windowWidth > 768 ? (
        <ul className="flex items-center gap-2">
          {menuLinks.map((link, index) => {
            return <HeaderButton {...link} key={index} />;
          })}
        </ul>
      ) : (
        <div className="shrink-0">
          <MobileHeader links={menuLinks} />
        </div>
      )}
      <Tooltip id="header-tooltip" />
    </nav>
  );
}
export default Header; 